import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';

const postInformes = (payload, fallback) => {
  if (!isApiEnabled()) {
    return Promise.reject(new Error('Informes requiere conexión con el servidor.'));
  }

  return api
    .post('/informes_api.php', payload)
    .then((response) => getApiData(response, fallback))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchInformesEspecialidades = (solicitanteId) =>
  postInformes(
    { accion: 'especialidades', solicitante_id: solicitanteId },
    'No se pudieron cargar las especialidades.'
  );

export const buscarInformesPacientes = (solicitanteId, especialidadCodigo, q) =>
  postInformes(
    {
      accion: 'buscar',
      solicitante_id: solicitanteId,
      especialidad_codigo: especialidadCodigo || '',
      q: q || '',
    },
    'No se pudieron buscar pacientes.'
  );

export const fetchInformesPendientes = (solicitanteId, especialidadCodigo, modo) =>
  postInformes(
    {
      accion: 'pendientes',
      solicitante_id: solicitanteId,
      especialidad_codigo: especialidadCodigo || '',
      modo: modo || 'sin_evaluacion',
    },
    'No se pudo cargar el listado.'
  );

export const fetchInformesMenu = (solicitanteId, estudioId) =>
  postInformes(
    { accion: 'menu', solicitante_id: solicitanteId, estudio_id: estudioId },
    'No se pudo abrir el menú de informes.'
  );

export const fetchInformesReportesDiarios = (solicitanteId, estudioId) =>
  postInformes(
    { accion: 'reportes_diarios', solicitante_id: solicitanteId, estudio_id: estudioId },
    'No se pudieron cargar los reportes diarios.'
  );

export const fetchInformesDocumento = (solicitanteId, estudioId, tipo, numeroAvance = 0) =>
  postInformes(
    {
      accion: 'obtener_documento',
      solicitante_id: solicitanteId,
      estudio_id: estudioId,
      tipo,
      numero_avance: numeroAvance,
    },
    'No se pudo cargar el informe.'
  );

export const saveInformesDocumento = (payload) =>
  postInformes(
    { accion: 'guardar_documento', ...payload },
    'No se pudo guardar el informe.'
  );
